import React from 'react'

import { PrefixSelect, Util } from '@grandvision/forms'
import { useIntl } from '@grandvision/state'

export const Salutation = () => {
  const { getLabel } = useIntl()
  const options = React.useMemo(
    () =>
      Util.createSimpleSelectOptions(
        ['mr', 'mrs', 'miss', 'ms', 'dr', 'mx'].map((key) =>
          getLabel(`checkout.contact.honorific.${key}`)
        )
      ),
    [getLabel]
  )

  return (
    <PrefixSelect
      options={options}
      label={getLabel('checkout.contact.honorific.title')}
      errorMessage={getLabel('checkout.contact.honorific.errorMessage')}
      placeholder={getLabel('checkout.contact.honorific.title')}
      required={true}
    />
  )
}
